import { BadgeColor, CardProgressState } from '@exfluential/ui';
import { UserProgressStatus } from '~/api/learning';

/**
 * Map a progress status onto the shared card progress state, which drives the
 * bar color and whether the bar renders as complete.
 */
export const getCardProgressState = (
  status: UserProgressStatus | undefined,
): CardProgressState => {
  switch (status) {
    case UserProgressStatus.IN_PROGRESS: {
      return CardProgressState.IN_PROGRESS;
    }
    case UserProgressStatus.AWAITING_REVIEW: {
      return CardProgressState.IN_REVIEW;
    }
    case UserProgressStatus.COMPLETED:
    case UserProgressStatus.PASSED: {
      return CardProgressState.COMPLETED;
    }
    case UserProgressStatus.NOT_PASSED: {
      return CardProgressState.FAILED;
    }
    default: {
      return CardProgressState.NOT_STARTED;
    }
  }
};

/**
 * Map a progress status onto the shared Badge color pair.
 */
export const getProgressStatusBadgeColor = (
  status: UserProgressStatus,
): BadgeColor => {
  switch (status) {
    case UserProgressStatus.IN_PROGRESS:
    case UserProgressStatus.AWAITING_REVIEW: {
      return BadgeColor.INFO;
    }
    case UserProgressStatus.COMPLETED:
    case UserProgressStatus.PASSED: {
      return BadgeColor.SUCCESS;
    }
    case UserProgressStatus.NOT_PASSED: {
      return BadgeColor.ERROR;
    }
    default: {
      return BadgeColor.NEUTRAL;
    }
  }
};
